module.exports = __webpack_public_path__ + "img/image 4.9c506203.png";